import React, {useState, useEffect, useRef} from 'react'

import classes from './PopupModuleStars.module.css'
import Popup from '@/components/shared/Popup/Popup';
import PopupsManager from 'react-sdk/PopupsManager';
import AppState, { POPUPS } from '@/js/AppState';
import Minigame from '@/js/Minigames/Minigame';
import Minigames from '@/js/Minigames/Minigames';
import Star from '@/components/shared/Star/Star';
import Button from '@/components/shared/Button/Button';




const PopupModuleStars = ({debriefText, onClose}) => {


  let moduleId = PopupsManager.getData(POPUPS.MODULE_STARS)

  let result = AppState.getLastModuleResult(moduleId);
  /** @type {Array<Minigame>} */
  let moduleMgs = result.mgIds.map(mgId => Minigames.get(mgId))
  let starNb = result.stars


  
  return (
    <Popup className={classes.PopupModuleStars}>
      {/*moduleMgs &&
      <div className={classes.stars_ctnr}>
        <SvgStar className={clsx(starNb < 1 && classes.inactive)} ></SvgStar>
        <SvgStar className={clsx(starNb < 2 && classes.inactive)} ></SvgStar>
        <SvgStar className={clsx(starNb < 3 && classes.inactive)} ></SvgStar>
      </div>*/}


      <div className={classes.moduleScores}>
        {moduleMgs.map((mg, index) => {
          let stars = mg.getStars()
          let icon = mg.icon
          return (
            <div className={classes.moduleScore}>
              <div className={classes.moduleIcon}>
                <div className={classes.MinigameIcon}>
                  {icon && <img src={icon} />}
                </div>
              </div>
              <span>{mg.name}</span>
              <div className={classes.ministars}>
                {new Array(3)
                .fill("")
                .map((_, index) => {
                  if(index < stars) return <div className={classes.ministar}><Star filled /></div>
                  else return <div className={classes.ministar}><Star /></div>
                })}



              </div>
              
            </div>
          )
        })}
      </div>

      <div className={classes.stars}>
        {new Array(3)
        .fill("")
        .map((_, index) => {
          if(index < starNb) return <div className={classes.star}><Star filled /></div>
          else return <div className={classes.star}><Star /></div>
        })}
      </div>
      

      {debriefText &&
        <div className={classes.debrief_ctnr}>
          <div className={classes.debrief} dangerouslySetInnerHTML={{__html: debriefText}} />
          
          {onClose &&
            <div className={classes.btn_ctnr}>
              <Button onClick={() => { PopupsManager.close(POPUPS.MODULE_STARS); onClose();}}> Continuer</Button>
            </div>
          }
        </div>
      }


    </Popup>
  );
};

export default PopupModuleStars;
